import { ChangeDetectionStrategy, Component, output, input } from '@angular/core';

import { InfoboxComponent } from '@core/components-infobox-legacy';
import { TranslatePipe } from '@core/i18n-legacy';

@Component({
  selector: 'rt-assigned-product-message',
  templateUrl: './assigned-product-message.component.html',
  styleUrls: ['./assigned-product-message.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.disabled]': 'disabled()',
  },
  imports: [InfoboxComponent, TranslatePipe],
})
export class AssignedProductMessageComponent {
  public readonly disabled = input<boolean>(false);
  public finishOrder = output<void>();
}
